console.log("running in ldvsg configuration")